<div class="d-flex flex-wrap gap-3 mb-3">
  <div class="d-none d-lg-block">
    <ul class="nav nav-tabs">
      <li class="nav-item navigation-item" (click)="changeTab('jobs')">
        <a
          class="nav-link"
          data-toggle="tab"
          [ngClass]="selectedItem == 'jobs' ? 'active fw-semibold' : ''"
        >
          Jobs
        </a>
      </li>

      <li class="nav-item navigation-item" (click)="changeTab('incidents')">
        <a
          class="nav-link"
          data-toggle="tab"
          [ngClass]="selectedItem == 'incidents' ? 'active fw-semibold' : ''"
        >
          Incidents
        </a>
      </li>
      <li
        class="nav-item navigation-item"
        (click)="changeTab('checkpoint-scans')"
      >
        <a
          class="nav-link"
          data-toggle="tab"
          [ngClass]="
            selectedItem == 'checkpoint-scans' ? 'active fw-semibold' : ''
          "
        >
          Checkpoint Scans
        </a>
      </li>
      <li class="nav-item navigation-item" (click)="changeTab('sites')">
        <a
          class="nav-link"
          data-toggle="tab"
          [ngClass]="selectedItem == 'sites' ? 'active fw-semibold' : ''"
        >
          Sites
        </a>
      </li>
    </ul>
  </div>
  <div class="d-block d-lg-none w-100">
    <select
      class="form-select form-select-lg"
      [value]="selectedItem"
      (change)="selectDropDown($event)"
    >
      <option value="jobs">Jobs</option>
      <option value="incidents">Incidents</option>
      <option value="checkpoint-scans">Checkpoint Scans</option>
      <option value="sites">Sites</option>
    </select>
  </div>
</div>
@switch (selectedItem) {
  @case ("sites") {
    <gtapp-sites> </gtapp-sites>
  }
  @case ("jobs") {
    <gtapp-jobs> </gtapp-jobs>
  }
  @case ("incidents") {
    <gtapp-incidents> </gtapp-incidents>
  }
  @case ("checkpoint-scans") {
    <gtapp-checkpoint-scans> </gtapp-checkpoint-scans>
  }
}
